import React from 'react';
import { useTranslation } from 'react-i18next';

import RegisterForm from '@layouts/RegisterForm';

export default function Recruit() {
    const { t } = useTranslation();
    
    return (
        <div className=" pos-relative w-full flex-col flex-m" style={{ justifyContent: 'flex-start', }}>
            <div className='pos-relative' style={{ width: 200, margin: '0 auto 0', zIndex: 2 }}>
                <img src='/images/setting/downline.png' alt="downline" className='w-full' />
            </div>
            <div className='pos-relative cl-white textfield-bkg w-full'>{/* */}
                <div className='txt-center'>
                    <p className='fs-21 inter-bold cl-theme'>{t('title.recruit')}</p>
                    <p className='inter-normal fs-13 cl-label lh-12 p-t-5 max-w-full' style={{ width: 350, margin: '0 auto' }}>{t('settingDescription.recruit')}</p>
                </div>
                <RegisterForm url='/user/register' />
            </div>
        </div>
    );
}